import React from "react";
import loadable from "@loadable/component";

import FooterSkeleton from "./footer-skeleton";

const FooterContent = loadable(() => import("./Footer"));

const Footer = () => <FooterContent fallback={<FooterSkeleton />} />;

export default Footer;
